import { createSlice } from '@reduxjs/toolkit';
// ----------------------------------------------------------------------
import apiNotification from '../../api/notification';
function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  notifications: [],
  viewNotification: [],
};
//
const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    statusViewNotification(state, action) {
      const participants = action.payload;
      state.viewNotification = participants;
    },
    statusListNotification(state, action) {
      const participants = action.payload;
      state.notifications = participants;
    },
    statusAddNotification(state, action) {
      const participants = action.payload;
      state.viewNotification.unshift(participants);
    },
    statusNotiFy(state, action) {
      const participants = action.payload;
      state.viewNotification.unshift(participants);
    }
  }
});

// Reducer
export default slice.reducer;

export function listNotification(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const res_noti = await apiNotification.view(param);
    try {
      dispatch(slice.actions.statusListNotification(res_noti.data.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function viewNotification(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const res_noti = await apiNotification.viewNoti(param);
    try {
      dispatch(slice.actions.statusViewNotification(res_noti.data.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function addNotification(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusAddNotification(param));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
